export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-1.96db4a00.png";